@if (customer$ | async; as customer) {
  <agr-page-toolbar
    [isEmpty]="isEmpty$ | async"
    [emptyTitle]="'noAdvices' | translate"
    [emptyDescription]="((hasSearch$ | async) ? 'noFieldsForThisSearch' : 'noFields') | translate"
    emptyActionIcon="navigate_next"
    [showEmptyAction]="(hasSearch$ | async) === false"
    [emptyActionText]="'fieldPlan' | translate"
    emptyActionColor="accent"
    emptyActionIcon="navigate_next"
    (emptyAction)="openFieldPlan()"
    [buttonItems]="buttonItems$ | async"
    (buttonAction)="buttonAction($event)"
    [pageTitle]="
      ((hasFilteredCropFieldAdvices$ | async)
        ? (showCropFieldAdvices$ | async)?.length + '/' + (cropFieldAdvices$ | async)?.length
        : '') +
      ' ' +
      ('advices' | translate) +
      ' ' +
      customer?.name +
      ' ' +
      customer?.externalId
    "
    [hasSelection]="hasFilteredCropFieldAdvices$ | async"
    (deselect)="deselect()"
    [hasPrimaryAction]="true"
    primaryActionIcon="list_alt"
    [primaryActionText]="'createAdviceReport'"
    (primaryAction)="createAdviceReport()"
  >
    <div displayAlways class="wrapper--spacing-horizontal layout--margin-top">
      @if (filterReady) {
        <agr-filter [config]="filterConfig"></agr-filter>
      }
      <app-copy-advice-status></app-copy-advice-status>
    </div>
    @if (showCropFieldAdvices$ | async; as cropFieldAdvices) {
      <mat-list data-test="advice-list">
        @if (cropFieldsHasSyncStatus(cropFieldAdvices)) {
          <mat-list-item>
            <!-- Empty icon for alignment -->
            <mat-icon matListItemIcon></mat-icon>
            <div class="flex--row">
              <div class="flex--align-center">
                <mat-checkbox
                  [checked]="areAllCropFieldsSelected"
                  [indeterminate]="someSelected(cropFieldAdvices)"
                  (change)="selectAllChanged($event.checked, cropFieldAdvices)"
                  color="primary"
                  data-test="select-cropfield"
                ></mat-checkbox>
              </div>
              @if (selectedRowsCount(cropFieldAdvices) > 0) {
                <div class="spacing--margin-vertical spacing--margin-left">
                  <button
                    class="delete-btn"
                    mat-stroked-button
                    (click)="deleteCropFields(cropFieldAdvices)"
                  >
                    <mat-icon aria-label="Delete order lines" iconPositionEnd>delete</mat-icon>
                    {{
                      locale.translate('deleteCropFields.button', {
                        linesLength: selectedRowsCount(showCropFieldAdvices$ | async).toString(),
                      }) | translate
                    }}
                  </button>
                </div>
              }
            </div>
          </mat-list-item>
        }
        @for (element of showCropFieldAdvices$ | async; track element) {
          <mat-list-item data-test="advice-item" class="spacing--margin-top">
            <mat-icon
              [matTooltip]="getSyncStatusIconTooltipText(element)"
              [class]="['status-icon', getSyncStatusColor(element)]"
              matListItemIcon
            >
              agriculture
            </mat-icon>
            @if (cropFieldsHasSyncStatus(cropFieldAdvices)) {
              <mat-checkbox
                color="primary"
                [checked]="element.selected"
                (change)="element.selected = !element.selected"
                data-test="select-cropfield"
              >
                <span matListItemTitle>
                  {{ element.name }} ({{ element.areaInHectares | agrNumber }}
                  <span class="hectares-column">Ha</span>)
                </span>
                <span matListItemLine>
                  {{ element.crop.name }}
                  @if (element.cropVariety) {
                    <span>({{ element.cropVariety?.name }})</span>
                  }
                </span>
                <span matListItemLine>
                  {{ (fertilizationTreatments$(element.cropFieldId) | async)?.length }}
                  <span>{{
                    ((fertilizationTreatments$(element.cropFieldId) | async)?.length === 1
                      ? 'FertilizationTreatment'
                      : 'FertilizationTreatments'
                    ) | translate
                  }}</span
                  >, {{ (gbmTreatments$(element.cropFieldId) | async)?.length }}
                  <span>{{
                    ((gbmTreatments$(element.cropFieldId) | async)?.length === 1
                      ? 'GBMTreatment'
                      : 'GBMTreatments'
                    ) | translate
                  }}</span>
                </span>
              </mat-checkbox>
            }
            @if (!cropFieldsHasSyncStatus(cropFieldAdvices)) {
              <ng-container>
                <span matListItemTitle>
                  {{ element.name }} ({{ element.areaInHectares | agrNumber }}
                  <span class="hectares-column">Ha</span>)
                </span>
                <span matListItemLine>
                  {{ element.crop.name }}
                  @if (element.cropVariety) {
                    <span>({{ element.cropVariety?.name }})</span>
                  }
                </span>
                <span matListItemLine>
                  {{ (fertilizationTreatments$(element.cropFieldId) | async)?.length }}
                  <span>{{
                    ((fertilizationTreatments$(element.cropFieldId) | async)?.length === 1
                      ? 'FertilizationTreatment'
                      : 'FertilizationTreatments'
                    ) | translate
                  }}</span
                  >, {{ (gbmTreatments$(element.cropFieldId) | async)?.length }}
                  <span>{{
                    ((gbmTreatments$(element.cropFieldId) | async)?.length === 1
                      ? 'GBMTreatment'
                      : 'GBMTreatments'
                    ) | translate
                  }}</span>
                </span>
              </ng-container>
            }
            <agr-responsive-actions
              style="height: auto"
              matListItemMeta
              [items]="
                (adviceActions$ | async) !== null
                  ? (adviceActions$ | async)[element.cropFieldId]
                  : []
              "
              (action)="adviceAction($event, element)"
            ></agr-responsive-actions>
          </mat-list-item>
        }
      </mat-list>
    }
  </agr-page-toolbar>
}

<app-overview-legend />
